import React, { useState } from "react";

import { useNavigate, useLocation } from "react-router-dom";

import { Link } from "react-router-dom";

// @mui/material components

import CircularProgress from '@mui/material/CircularProgress';


// @mui/icons-material
import Visibility from "@mui/icons-material/Visibility";

// core components
import Grid from "@mui/material/Grid";

import Button from "../components/Button.jsx";
import OthelloTitulo from "../componentsothello/OthelloTitulo.jsx";

import {  ResultadoPagoReserva } from "../othelloConstantes.jsx";

export default function ReservaFinPasarela({ ...props }) {
    const { literal, idRol, tipooficina, loginmodoreserva, loginapps, idUser } = props;

    //Ejmplo de obtener un parametro de la URL        
    //ID={Id_Oficina}&dt={Resultado.ID_Reserva}.1

    const navigate = useNavigate();

    const { search } = useLocation();

    const [loading, setLoading] = React.useState(true);

    const [id, setid] = React.useState(-1);
    const [data, setdata] = React.useState(null);
    const [sign, setsign] = React.useState(null);
    const [resultadopago, setresultadopago] = React.useState(null);

    React.useEffect(() => {

        let url = search;
        let params = new URLSearchParams(url);

        let id = params.get('ID');
        let dt = params.get('dt');
        let sign = params.get('sign');

        setid(id);
        setdata(dt);
        setsign(sign);

        getDataPage(id, dt, sign);
    }, [loading]);


    //METODOS GLOBALES DE LA PAGINA

    const getDataPage = (id, data, sign) => {

        if (id != null && data != null && sign != null) {
            var jsonData = JSON.stringify({ id: id, data: data, sign: sign });

            fetch('api/Data/ConfirmarDenegarPagoReserva', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: jsonData

            }).then(response => response.json()).then(res => {
                if (res != null) {
                    setLoading(false);
                    setresultadopago(res);
                }
                else
                    navigate('/admin/profile');
                //this.props.history.push('/admin/profile');                               

            }).catch(error => {
                navigate('/admin/profile');
                //this.props.history.push('/admin/profile');               
            });
        }
        else
            navigate('/admin/profile');
        //this.props.history.push('/admin/profile');

    }

    function renderResultadoPago(resultado) {

        if (resultado != null) {
            let pagoOk = resultado.resultadoPago == ResultadoPagoReserva.OK;

            let titulo = pagoOk ? "Operación realizada con exito" : "Operación no completada ";

            return <Grid item xs={12}>
                <OthelloTitulo titulo={titulo} backgroundColor={pagoOk ? "green" : "red"} />
                {pagoOk ?
                    <p style={{ fontSize: 16, marginTop: 10, marginLeft: 6 }}>El proceso de pago de la operación se ha completado correctamente.<br /><br />

                        Si tiene cualquier duda o consulta, póngase en contacto con nosotros.<br /><br />

                        Muchas gracias.<br /><br />
                    </p> :
                    <p style={{ fontSize: 16, marginTop: 10, marginLeft: 6 }}>
                        El proceso de pago de la operación <strong>NO</strong> se ha completado correctamente.<br /><br />

                        Si ha tenido algun problema durante el proceso vuelta a intertarlo mas tarde o  ante cualquier duda o consulta póngase en contacto con nosotros.<br /><br />

                        Muchas gracias.<br /><br />
                        Codigo Error - {resultado.resultadoPago}<br /><br />
                    </p>}

                <Button color="facebook" component={Link} to="/admin/profile">Volver</Button>
            </Grid>;
        }
        else
            return "Cargando";
    }


    let resultado = loading ? <p><CircularProgress color="secondary" /></p> : renderResultadoPago(resultadopago);

    return (
        <Grid container>
            {resultado}
        </Grid>
    );
}

